<template>
  <div class="ruleForm question">
    <!-- 左侧 -->
    <div class="question-left">
      <div class="template">
        <div class="block-title">题型模板</div>
        <!-- <div class="template-group">
          <span>下载题型模板：</span>
          <el-button
            type="primary"
            size="small"
            @click="
              $downloadFile(
                '调研问卷题型模板.xlsx',
                'http://cdn.yxvzb.com/WEB/SaaS/static/temp/%E8%B0%83%E7%A0%94%E9%97%AE%E5%8D%B7%E9%A2%98%E5%9E%8B%E6%A8%A1%E6%9D%BF.xlsx'
              )
            "
          >
            <i class="el-icon-download" style="margin-right:5px;"></i>下 载
          </el-button>
        </div>-->
        <div class="template-group">
          <span>上传问卷内容：</span>
          <importTemplate
            :projectId="projectId"
            @questionListUpdate="questionListUpdate"
          ></importTemplate>
        </div>
        <p>通过本功能上传问卷将会覆盖之前设置好的内容。</p>
      </div>
      <div class="question-type">
        <div class="block-title">题目类型</div>
        <ul v-for="item in typeList" :key="item.title">
          <li>
            <p class="question-left-title">{{ item.title }}</p>
            <ul class="question-left-item2">
              <li
                class="hand"
                v-for="item2 in item.list"
                :key="item2.title"
                @click="pushQuestion(item2)"
              >
                <img :src="item2.icon" alt />
                <span>{{ item2.title }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="question-right">
      <div class="question-right-c">
        <!-- banner -->
        <div class="question-right-top">
          <div
            class="question-right-top-upload"
            @click="handleUpload"
            v-if="!common.banner"
          >
            <div style="height: 90px;"></div>
            <p>
              建议尺寸3:2的尺寸比例
              <br />
              格式要求
              <br />
              JPEG、PNG、JPG
              <br />
              图片大小
              <br />
              5M以下
            </p>
            <img class="upload-icon" src="@/assets/shangchuan.png" alt />
          </div>
          <img
            class="question-right-top-upload"
            v-else
            :src="common.banner"
            alt
            @click="handleUpload"
          />
          <UploadImgOne
            :initUrl="common.banner"
            @upload-done="waitPicDone"
            :noNeedDefaultImg="true"
            ref="uploadOne"
            style="display:none"
          ></UploadImgOne>
          <el-input
            type="textarea"
            autosize
            style="margin-bottom:10px"
            :maxlength="50"
            v-model="common.title"
            placeholder="问卷标题（最多50个汉字）"
          ></el-input>
          <el-input
            type="textarea"
            autosize
            style="margin-bottom:30px"
            v-model="common.explainSm"
            placeholder="此处输入问卷说明"
            :maxlength="50"
          ></el-input>
        </div>
        <vueDraggable
          ghostClass="ghost"
          handle=".mover"
          v-model="questionList"
          chosenClass="chosen"
          forceFallback="true"
          fallbackClass="draggingStyle"
          animation="1000"
          @end="onOver"
        >
          <transition-group>
            <el-card
              :id="item.id"
              shadow="hover"
              class="item"
              v-for="(item, index) in questionList.slice(0, scrollIndex)"
              :key="item.id"
            >
              <!-- 上部 -->
              <div class="item-title">
                <!-- 删除 移动 等操作 -->
                <div class="item-mr">
                  <span style="margin-right: 10px;color:#999999">
                    [{{ item | questionTypeLabelFil }}]
                  </span>
                  <!-- //定位题、时刻题、被调研者来源这三个题都为必选 -->
                  <el-switch
                    v-if="
                      needMustFill(item.type) &&
                        ![16, 29, 30].includes(item.type)
                    "
                    style="margin-right:10px;"
                    v-model="item.isMustFill"
                    :active-value="1"
                    :inactive-value="0"
                    active-color="#13ce66"
                    inactive-color="#D9D9D9"
                    :active-text="item.isMustFill == 1 ? '必答' : '非必答'"
                  ></el-switch>
                  <el-tooltip
                    effect="light"
                    content="长按拖动题目"
                    placement="top-start"
                  >
                    <img class="move-img mover" src="@/assets/yidong.png" alt />
                  </el-tooltip>
                  <!-- <div style="font-size:14px;">
                      顺序
                      <el-input
                        class="question-edit-sort-input"
                        placeholder="顺序"
                        style="width:60px;padding:0;"
                        size="small"
                        :value="item.weight"
                        @blur="sortFlag = true"
                        @focus="sortFlag = false"
                        @input="val=>dealSortValue(val,item,item.weight)"
                      ></el-input>
                  </div>-->
                  <el-tooltip
                    effect="light"
                    content="点击删除题目"
                    placement="top-start"
                  >
                    <img
                      class="hand"
                      style="margin-left:15px"
                      src="@/assets/shanchu.png"
                      alt
                      @click="itemRemove(index)"
                    />
                  </el-tooltip>
                </div>
                <!-- 标题 -->
                <div class="item-title__p" style="display:flex">
                  <span
                    :style="
                      item.isMustFill === 1
                        ? {
                            color: 'red',
                            'line-height': '40px',
                            'margin-right': '5px'
                          }
                        : {
                            color: 'rgba(255,255,255,0)',
                            'margin-right': '5px'
                          }
                    "
                  >
                    *
                  </span>
                  <el-input
                    class="question-edit-sort-input textarea-title"
                    placeholder="顺序"
                    style="width:80px;margin-right:5px"
                    size="small"
                    @blur="dealSortValue('', item, item.weight)"
                    @focus="
                      event => {
                        sortFlag = false;
                        event.currentTarget.select();
                      }
                    "
                    :value="
                      (item.newWeight || item.weight) + dealQuestionList.length
                    "
                    @input="weightChange(item, $event)"
                  ></el-input>
                  <!-- <el-input
                    class="question-edit-sort-input textarea-title"
                    placeholder="顺序"
                    style="width:60px;margin-right:5px"
                    size="small"
                    :value="item.weight"
                    @blur="sortFlag = true;copyList()"
                    @focus="
                      sortFlag = false;
                      event => event.currentTarget.select();
                    "
                    @input="val => dealSortValue(val, item, item.weight)"
                  ></el-input>-->

                  <el-input
                    v-if="changeItemFlag === item.type + '_' + index + '_title'"
                    :id="item.type + '_' + index + '_title'"
                    class="textarea-title"
                    type="textarea"
                    autosize
                    v-model.trim="item.title"
                    :maxlength="200"
                    @focus="event => event.currentTarget.select()"
                    placeholder="标题最多可输入200个字"
                    @click.native="itemHover(item.type, index, 'title')"
                    @blur="itemOut"
                  />
                  <el-input
                    v-else
                    class="textarea-title"
                    type="textarea"
                    autosize
                    v-model.trim="item.title"
                    :maxlength="200"
                    disabled
                    @focus="event => event.currentTarget.select()"
                    placeholder="标题最多可输入200个字"
                    @click.native="itemHover(item.type, index, 'title')"
                    @blur="itemOut"
                  />
                </div>
              </div>
              <div
                style="margin-left:50px;padding:10px"
                class="remark-input"
                @click="itemHover(item.type, index)"
                @blur="itemOut"
              >
                <span style="line-height:32px;">备注：</span>
                <el-input
                  v-if="changeItemFlag === item.type + '_' + index + '_'"
                  :id="item.type + '_' + index + '_'"
                  type="textarea"
                  autosize
                  placeholder="如无备注信息，可不填（最多50字）"
                  style="width:320px"
                  v-model.trim="item.remark"
                  @focus="event => event.currentTarget.select()"
                  :maxlength="50"
                ></el-input>
                <el-input
                  v-else
                  :id="item.type + '_' + index + '_'"
                  :disabled="true"
                  type="textarea"
                  autosize
                  placeholder="如无备注信息，可不填（最多50字）"
                  style="width:320px"
                  v-model.trim="item.remark"
                  :maxlength="50"
                ></el-input>
              </div>
              <div class="item-content">
                <!-- 选择项 -->
                <div
                  class="item-content-inputs"
                  v-if="item.type < 4 && item.type > 0"
                >
                  <ul class="item-content-inputs-ul">
                    <li
                      v-for="(item2, index2) in item.list"
                      :key="index2"
                      @click="itemHover(item.type, index, index2, $event)"
                      @blur="itemOut"
                    >
                      <!-- 目标可编辑 -->
                      <div
                        v-if="
                          changeItemFlag ===
                            item.type + '_' + index + '_' + index2
                        "
                      >
                        <el-input
                          :id="item.type + '_' + index + '_' + index2"
                          type="textarea"
                          autosize
                          class="item2-input"
                          v-model.trim="item.list[index2]"
                          :maxlength="200"
                          @focus="event => event.currentTarget.select()"
                        />
                        <img
                          class="item2-remove hand"
                          src="@/assets/shanchu_yidianji.png"
                          alt
                          @click="item2Remove(index, index2)"
                          v-if="index2 != 0"
                        />
                      </div>
                      <!-- 不可编辑 -->
                      <el-input
                        type="textarea"
                        autosize
                        style="border-color:transparent"
                        class="item2-input"
                        v-else
                        :value="item2"
                        disabled
                      />
                    </li>
                  </ul>
                  <ul
                    class="item-content-inputs-add hand"
                    v-if="item.list.length < 50"
                  >
                    <li @click="item2Add(index)">
                      <img src="@/assets/xinzengxuanxiang.png" alt />
                      <span>新增选项</span>
                    </li>
                  </ul>
                </div>
                <!-- 单填空 -->
                <div class="item-content-textone" v-else-if="item.type == 4">
                  <el-input
                    size="small"
                    placeholder="请填写本项内容"
                    disabled
                  ></el-input>
                </div>
                <!-- 单填空/数字填空题 -->
                <div
                  class="item-content-textone item-content-19"
                  v-else-if="item.type == 19"
                >
                  <el-input
                    size="small"
                    placeholder="请填写本项内容"
                    disabled
                  ></el-input>
                  <div>
                    <span>填写限制：</span>
                    <el-input
                      v-model.trim="item.rule.minNum"
                      :placeholder="`${minFor19}`"
                      @input="
                        e => {
                          validate19Input(e, item, 'minNum');
                        }
                      "
                      @change="
                        e => {
                          validate19MinChange(e, item);
                        }
                      "
                    ></el-input>
                    <span>—</span>
                    <el-input
                      v-model.trim="item.rule.maxNum"
                      :placeholder="`${maxFor19}`"
                      @input="
                        e => {
                          validate19Input(e, item, 'maxNum');
                        }
                      "
                      @change="
                        e => {
                          validate19MaxChange(e, item);
                        }
                      "
                    ></el-input>
                  </div>
                  <el-checkbox
                    v-model="item.rule.numberType"
                    :true-label="1"
                    :false-label="0"
                    @change="
                      e => {
                        changeBoxFor19(e, item);
                      }
                    "
                  >
                    显示小数，勾选后允许填写小数点后两位
                  </el-checkbox>
                </div>
                <!-- 多填空 -->
                <div
                  class="item-content-inputs item-content-textmore"
                  v-else-if="item.type == 5"
                >
                  <ul class="item-content-inputs-ul">
                    <li
                      v-for="(item2, index2) in item.list"
                      :key="index2"
                      @click="itemHover(item.type, index, index2)"
                      @blur="itemOut"
                    >
                      <!-- 目标可编辑 -->
                      <div
                        v-if="
                          changeItemFlag ===
                            item.type + '_' + index + '_' + index2
                        "
                      >
                        <el-input
                          :id="item.type + '_' + index + '_' + index2"
                          type="textarea"
                          autosize
                          class="item2-input"
                          v-model.trim="item.list[index2]"
                          :maxlength="200"
                          @focus="event => event.currentTarget.select()"
                        />
                        <img
                          class="item2-remove hand"
                          src="@/assets/shanchu_yidianji.png"
                          alt
                          @click="item2Remove(index, index2)"
                          v-if="index2 != 0"
                        />
                      </div>
                      <!-- 不可编辑 -->
                      <el-input
                        type="textarea"
                        autosize
                        style="border-color:transparent"
                        class="item2-input"
                        v-else
                        :value="item2"
                        disabled
                      />
                      <el-input
                        size="small"
                        style="width:80%;padding:10px 0 0 0"
                        placeholder="请填写本项内容"
                        disabled
                      />
                    </li>
                  </ul>
                  <ul
                    class="item-content-inputs-add hand"
                    v-if="item.list.length < 50"
                  >
                    <li @click="item2Add(index, '问题')">
                      <img src="@/assets/xinzengxuanxiang.png" alt />
                      <span>新增选项</span>
                    </li>
                  </ul>
                </div>
                <!-- 打分 -->
                <div class="item-content-textone" v-else-if="item.type == 6">
                  <el-rate
                    style="font-size:30px"
                    disabled
                    text-color="#ff9900"
                  ></el-rate>
                </div>
                <!-- 上传附件 -->
                <div
                  class="item-content-textone enclosure"
                  v-else-if="fileTypeList.includes(item.type)"
                >
                  <ul style="justify-content:flex-start;">
                    <li
                      v-for="(item2, index) in item.fileListLength"
                      :key="index"
                      style="margin-right:5px;"
                    ></li>
                  </ul>
                  <p>文件仅支持{{ item.type | transType }}，不超过20M</p>
                  <div
                    style="display:flex;align-items:center;margin-top:5px;"
                    v-if="item.type === 13"
                  >
                    <span>最少图片数量：</span>
                    <el-input-number
                      size="mini"
                      v-model="item.fileListLength"
                      :max="10"
                      :min="1"
                      placeholder="最多10张"
                      @blur="avoidEmpty(item.fileListLength, index)"
                    ></el-input-number>
                    <el-switch
                      style="margin-left:10px;"
                      v-model="item.isMakeScenePicWatermark"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="时间水印"
                    ></el-switch>
                  </div>
                </div>
                <!-- 时间题 -->
                <div
                  v-else-if="[14, 29].includes(item.type)"
                  class="item-content-textone enclosure"
                >
                  <el-date-picker
                    disabled
                    type="datetime"
                    placeholder="选择时间（年/月/日/时/分）"
                    style="width:400px;margin-top:30px;"
                  ></el-date-picker>
                  <!-- 时刻题是否开启实时打卡 0未设置，1已设置-->
                  <div v-if="[29].includes(item.type)">
                    <el-switch
                      style="margin-top: 10px;"
                      v-model="item.realTimeCheckIn"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="实时打卡"
                    ></el-switch>
                  </div>
                </div>
                <!-- 月度题 -->
                <div
                  v-else-if="item.type == 15"
                  class="item-content-textone enclosure"
                >
                  <el-date-picker
                    disabled
                    type="month"
                    placeholder="选择时间（年/月）"
                    style="width:400px;margin-top:30px;"
                  ></el-date-picker>
                </div>
                <!-- 定位题 -->
                <div
                  v-else-if="item.type == 16"
                  class="item-content-textone enclosure"
                >
                  <div class="box">
                    <img src="http://cdn.yxvzb.com/WEB/SaaS/images/nail.png" />
                    <span>点击获取地理位置</span>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-switch
                      style="margin-right:20px;"
                      v-model="item.isOpenPicWatermark"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="时间水印"
                    ></el-switch>
                    <el-switch
                      v-model="item.isSetLocation"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-text="实时定位"
                    ></el-switch>
                  </div>
                </div>
                <!-- 描述题 -->
                <div class="item-content-textone" v-else-if="item.type == 18">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="item.list[0]"
                    :maxlength="300"
                    placeholder="请填写描述内容"
                  ></el-input>
                </div>
                <div
                  v-else-if="item.type == 20"
                  class="item-content-textone enclosure"
                ></div>
                <!-- 被调研者来源题 -->
                <div v-else-if="item.type == 30">
                  <div style="width: 100%;">
                    <el-select
                      style="width: 100%;"
                      v-model="item.list"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="请选择"
                      @change="val => handleChangeSource(item.list, val, index)"
                      @remove-tag="
                        (tag, index) =>
                          handleRemoveSourceTag(item.list, tag, index)
                      "
                    >
                      <el-option
                        v-for="item in sourceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                  <div style="margin-top: 20px;">
                    <el-input
                      size="small"
                      placeholder="请输入名称"
                      disabled
                    ></el-input>
                  </div>
                </div>
              </div>
            </el-card>
          </transition-group>
        </vueDraggable>
      </div>
      <div class="question-right-bts">
        <el-button
          :loading="submiting"
          :disabled="submiting"
          type="primary"
          style="margin-right:80px;"
          @click="save(false)"
        >
          保存
        </el-button>
        <el-button type="info" @click="toQuestion()">
          返回
        </el-button>
      </div>
    </div>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="1000px">
      <div class="preview">
        <iframe
          id="iframe"
          :src="ifrUrl"
          frameborder="0"
          scrolling="no"
          v-if="dialogVisible"
          @load="iframeLoad"
          width="375px"
          :height="ifrHeight"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button
          :loading="submiting"
          :disabled="submiting"
          type="primary"
          @click="save(false)"
        >
          保 存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui';
import vueDraggable from 'vuedraggable';
import { btLoading } from '@/Mixin/btLoading';
import { addUpdateQuestionnaire, questionnaireData } from '@/api/ajax';
import UploadImgOne from '@C/Common/UploadImgOne';
import { makeSure } from '@/Mixin/makeSure';
import Config from '@/config';
import { questionType } from '@/config/staticData';
import importTemplate from './importTemplate.vue';
import {
  validate19Input,
  validate19MaxChange,
  validate19MinChange,
  maxFor19,
  minFor19,
  validateSaveDataFor19,
  changeBoxFor19
} from './services/19.js';

import { mapState } from 'vuex';

export default {
  mixins: [btLoading, makeSure],
  data() {
    return {
      sourceOptions: [
        { label: '药店', value: '药店' },
        { label: '等级医院', value: '等级医院' },
        {
          label: '基层医疗机构',
          value: '基层医疗机构'
        },
        {
          label: '其他',
          value: '其他'
        }
      ], //被调研者来源题的下拉
      oldQuestionList: '', //存储初始数据
      maxFor19,
      minFor19,
      sortFlag: true, // 是否排序
      submiting: false,

      ifrUrl: `${Config.webViewUrl}${Config.webPath}/survey?previewFlag=1`,
      ifrHeight: '800px', // iframe 高度
      dialogVisible: false, // 是否显示预览
      draggable: true, // 是否可以拖拽，当为input时 false
      // 当目标滑到时可以编辑选项，此为可编辑的标识 item.type_item.id_item.list.index
      changeItemFlag: '',
      // 点击编辑标题 直接为index
      changeTitleFlagIndex: -1,
      dealQuestionList: [],
      questionListCopy: [],
      fileTypeList: [8, 9, 10, 11, 12, 13],
      // 题目类型   1 单选  2 多选  3 单项投票  4 单项填空 5 多项填空 6 打分题  7 地址 8 上传附件 9 pdf 10 word 11 excel 12 ppt 13 jpg/png
      typeList: [
        {
          title: '时间题：',
          list: [
            {
              title: '时刻题',
              type: 29,
              icon: require('@/assets/danxuanti.png')
            }
          ]
        },
        {
          title: '选择题：',
          list: [
            {
              title: '单选题',
              type: 1,
              icon: require('@/assets/danxuanti.png')
            },
            {
              title: '多选题',
              type: 2,
              icon: require('@/assets/duoxuanti.png')
            },
            {
              title: '单选投票题',
              type: 3,
              icon: require('@/assets/danxuantoupiaoti.png')
            },
            {
              title: '受访者来源',
              type: 30,
              icon: require('@/assets/duoxuantiankongti.png')
            }
          ]
        },
        {
          title: '填空题：',
          list: [
            {
              title: '单项填空题',
              type: 4,
              icon: require('@/assets/danxuantiankongti.png')
            },
            {
              title: '多项填空题',
              type: 5,
              icon: require('@/assets/duoxuantiankongti.png')
            },
            {
              title: '数字填空题',
              type: 19,
              icon: require('@/assets/duoxuantiankongti.png')
            },
            {
              title: '姓名填空题',
              type: 22,
              icon: require('@/assets/danxuanti.png')
            }
          ]
        },
        {
          title: '打分题：',
          list: [
            { title: '打分题', type: 6, icon: require('@/assets/dafenti.png') }
          ]
        },
        {
          title: '个人信息：',
          list: [
            { title: '姓名', type: 4, icon: require('@/assets/danxuanti.png') },
            { title: '手机', type: 4, icon: require('@/assets/danxuanti.png') },
            { title: '邮箱', type: 4, icon: require('@/assets/youxiang.png') },
            {
              title: '签名题',
              type: 20,
              icon: require('@/assets/youxiang.png')
            }
          ]
        },
        {
          title: '附件上传：',
          list: [
            { title: 'PDF上传', type: 9, icon: require('@/assets/fujian.png') },
            {
              title: 'WORD上传',
              type: 10,
              icon: require('@/assets/fujian.png')
            },
            {
              title: 'PPT上传',
              type: 12,
              icon: require('@/assets/fujian.png')
            },
            {
              title: 'EXCEL上传',
              type: 11,
              icon: require('@/assets/fujian.png')
            },
            {
              title: '图片上传',
              type: 13,
              icon: require('@/assets/fujian.png')
            }
          ]
        },
        {
          title: '信息提交：',
          list: [
            {
              title: '时间题',
              type: 14,
              icon: require('@/assets/dafenti.png')
            },
            {
              title: '月度题',
              type: 15,
              icon: require('@/assets/dafenti.png')
            },
            { title: '定位题', type: 16, icon: require('@/assets/dafenti.png') }
          ]
        },
        {
          title: '描述：',
          list: [
            {
              title: '描述题',
              type: 17,
              icon: require('@/assets/dafenti.png')
            }
          ]
        }
      ],
      /**  questionList 渲染数据
       *    内部结构 ：
       * {
       *   type: item.type,
       *   list: ["选项1", "选项2", "选项3", "选项4"],
       *   title: `此题为${item.title}`,
       *   id: Date.now()
       * }
       */
      questionList: [],
      questionListOrigin: [], //对比的源数组
      dragging: null, // drag 当前 数据
      commonOrigin: {}, //对比的源对象
      common: {
        banner: '', // 封面图地址
        title: '', // 标题
        explainSm: '', // 描述
        id: '' // 问卷ID
      },
      scrollTop: 0,
      scrollIndex: 60
    };
  },
  components: {
    UploadImgOne,
    importTemplate,
    vueDraggable
  },
  filters: {
    transType(v) {
      let obj = {
        8: '文件',
        9: 'pdf',
        10: 'word',
        11: 'excel',
        12: 'ppt',
        13: 'jpg/png'
      };
      return obj[v];
    },
    questionTypeFil(v) {
      return (questionType[v] || { label: '' }).label;
    }
  },
  computed: {
    ...mapState({
      homeProject: state => state.homeProject,
      projectType: state => state.homeProject.projectType,
      projectId: state => state.homeProject.id
    }),

    questionListByComputed() {
      if (this.sortFlag) {
        return this.questionList;
      }
      return (this.questionList || []).sort((a, b) => a.weight - b.weight);
    }
  },
  methods: {
    //被调研者来源题至少有一个
    handleRemoveSourceTag(data, tag) {
      if (data.length == 0) {
        data.push(tag);
      }
    },
    handleChangeSource(data) {
      if (data.length == 0) {
        data.push('药店');
      }
    },
    validate19Input,
    validate19MaxChange,
    validate19MinChange,
    changeBoxFor19,
    weightChange(item, event) {
      if (!item.beforeWeight) {
        item.beforeWeight = item.weight;
      }
      this.$set(item, 'weight', Number(event) - this.dealQuestionList.length);
      // item.weight = Number(event)
    },
    copyList() {
      this.$set(this, 'questionList', this.questionListCopy);
    },
    questionListUpdate(list) {
      if (!Array.isArray(list)) {
        return;
      }
      this.questionList = list;
    },
    onOver() {
      this.questionList.forEach((question, index) => {
        question.weight = index + 1;
      });
    },
    needMustFill(type) {
      return ![17].includes(type) ? 1 : 0;
    },
    checkProjectId() {
      this.$message.error('项目信息已丢失，请重新选择项目');
      this.$router.go(-1);
    },
    avoidEmpty(val, index) {
      if (!val) {
        this.$message({
          message: '上传附件的数量最少为1',
          type: 'warning'
        });
        this.questionList[index].fileListLength = 1;
      }
    },
    handleUpload() {
      this.$refs.uploadOne.$refs.uploader.$refs['upload-inner'].handleClick();
    },
    waitPicDone(v) {
      this.common.banner = v;
    },
    // 设置修改title 下标
    setTitleFlag(index) {
      this.changeTitleFlagIndex = index;
    },
    // 标题input out事件重置标识
    titleBlur(item) {
      if (!item.title.length) {
        item.title = '默认标题';
      }
      this.changeTitleFlagIndex = -1;
    },
    // 选项移出时重置标识
    itemOut() {
      this.changeItemFlag = '';
    },
    // 选项移入写入标识
    itemHover(parentType, parentId, index) {
      this.changeItemFlag = `${parentType}_${parentId}_${
        index === undefined ? '' : index
      }`;
      this.$nextTick(() => {
        document
          .getElementById(
            parentType +
              '_' +
              parentId +
              '_' +
              (index === undefined ? '' : index)
          )
          .focus();
      });
    },

    // 添加选题
    pushQuestion(item) {
      // 只允许添加一道定位题、时刻题、被调研者来源
      if (
        [29, 30, 16].includes(item.type) &&
        this.questionList.findIndex(i => i.type === item.type) > -1
      ) {
        return;
      }
      const lastSort = parseInt(
        (this.questionListByComputed.slice(-1)[0] || {}).weight || 0
      );
      let rule = {};
      if (item.type === 19) {
        rule = {
          minNum: '',
          maxNum: '',
          numberType: 0 // 1显示小数 0不显示
        };
      }
      this.questionList.push({
        isMustFill: this.needMustFill(item.type),
        type: item.type,
        //被调研者来源的默认值
        list:
          item.type === 30
            ? ['药店', '等级医院', '基层医疗机构', '其他']
            : ['选项1'],
        title: `此题为${item.title}（点击编辑题干）`,
        id: Date.now() + this.questionList.length * 10, // 新建没有ID，使用时间戳
        fileListLength: 1,
        weight: isNaN(lastSort) ? 0 : lastSort + 1,
        rule
      });
    },
    // 删除选项
    item2Remove(parentIndex, childIndex) {
      this.questionList[parentIndex].list.splice(childIndex, 1);
    },
    // 添加选项
    item2Add(parentIndex) {
      this.questionList[parentIndex].list.push(
        `选项${this.questionList[parentIndex].list.length + 1}`
      );
    },
    // 删除整项
    itemRemove(index) {
      this.questionList.splice(index, 1);
      this.questionList.forEach((question, index) => {
        question.weight = index + 1;
      });
    },
    dealSortValue(val, item) {
      if (!item.beforeWeight) {
        return;
      }
      // item.beforeWeight = item.weight
      // item.weight = item.newWeight
      if (item.weight > this.questionList.length) {
        item.weight = this.questionList.length;
      }
      this.questionList.splice(item.beforeWeight - 1, 1);
      this.questionList.splice(item.weight - 1, 0, item);
      this.questionList = (this.questionList || []).sort(
        (a, b) => a.weight - b.weight
      );
      this.questionList.forEach((question, index) => {
        question.beforeWeight = undefined;
        question.weight = index + 1;
      });
    },
    // dealSortValue(val, item, sort) {
    //   this.questionListCopy = JSON.parse(JSON.stringify(this.questionList))
    //   if (val >= this.questionListCopy.length) {
    //     val = this.questionListCopy.length;
    //   }
    //   if(val < 1){
    //     val = 1
    //   }
    //   this.questionListCopy.splice(item.weight - 1, 1);
    //   this.questionListCopy.splice(val - 1, 0, item);
    //   // this.questionList = (this.questionList || []).sort((a, b) => a.weight - b.weight);
    //   this.questionListCopy.forEach((question, index) => {
    //     question.weight = index + 1;
    //   });
    //   // const value = val.replace(/[^0-9]/g, '');
    //   // item.weight = value ? parseInt(value) : '';
    // },
    // 保存
    async save(isAutoSave = false) {
      if (this.submiting) return;
      if (this.questionList.length > 256) {
        Message({ message: '题目数量超过256个，请重新编辑', type: 'error' });
        return;
      }
      let data = {
        ...this.common,
        projectId: this.projectId,
        projectType: this.projectType,
        questions: []
      };
      this.questionList.forEach((item, index) => {
        let { list, id, ...option } = item;
        data.questions[index] = item;
        // 新建时没有ID，使用时间戳的不提交ID字段
        if (data.questions[index].id < 10000000) {
          data.questions[index].id = id;
        }
        // 数字题保存时设置默认最小、大值
        if (option.type == 19) {
          const resp19 = validateSaveDataFor19(data.questions[index]);
          if (!resp19.status) {
            this.$message({
              showClose: true,
              message: resp19.message,
              type: 'error'
            });
            throw new Error(resp19.message);
          }
        }
        if (option.type == 5) {
          data.questions[index].manyTitleJson = list;
        } else if (this.fileTypeList.includes(option.type)) {
          //上传文件类型
          data.questions[index].optionJson = Array.isArray(item.fileListLength)
            ? item.fileListLength
            : [item.fileListLength];
        } else {
          data.questions[index].optionJson = list;
        }
        data.questions[index].weight = data.questions[index].weight || 0;
        data.questions[index] = JSON.stringify(data.questions[index]);
      });
      this.dialogVisible = false;
      if (isAutoSave) {
        if (this.questionList.length > 0) {
          const { isExists, items } = await this.$checkCopyProjectBIConfigs({
            projectId: this.projectId,
            getAjaxResp: true
          });
          //创建比对的数据
          let otherQuestionList = {
            common: JSON.parse(JSON.stringify(this.common)),
            questionList: JSON.parse(JSON.stringify(this.questionList))
          };
          //剔除不比对的数据
          otherQuestionList.questionList.forEach(item => {
            delete item.manyTitleJson;
            delete item.optionJson;
            //改成统一格式进行对比
            if (typeof item['fileListLength'] == 'number') {
              item.fileListLength = [item.fileListLength];
            }
          });
          //剔除不比对的数据
          this.oldQuestionList.questionList.forEach(item => {
            delete item.manyTitleJson;
            delete item.optionJson;
            if (item.type && item.type == 13) {
              item.isMakeScenePicWatermark = 0;
            }
            //改成统一格式进行对比
            if (typeof item['fileListLength'] == 'number') {
              item.fileListLength = [item.fileListLength];
            }
          });
          let dataEqual = '';
          try {
            dataEqual = this.deepEqual(this.oldQuestionList, otherQuestionList);
          } catch (error) {
            console.log(error + '比对数据出错了！');
          }
          //isModified=1会清空BI设置，=0不清空
          data.isModified = dataEqual == true ? 0 : 1;
          // 自动保存
          await addUpdateQuestionnaire(data);
          //Origin源数据用于保存时对比是否编辑
          //保存时将源对比数组更新
          this.questionListOrigin = JSON.parse(
            JSON.stringify(this.questionList)
          );
          this.commonOrigin = JSON.parse(JSON.stringify(this.common));
          this.$message.success(
            isExists && items && !dataEqual
              ? `您的项目问卷信息自动保存成功，BI中${items}数据已被清空；`
              : '自动保存成功'
          );
          this.$sentry.captureMessage(`问卷自动保存-${this.projectId}`, {
            level: 'info',
            contexts: {
              data: {
                json: JSON.stringify(data)
              }
            }
          });
        }
      } else {
        this.submiting = true;
        this.$checkCopyProjectBIConfigs({
          projectId: this.projectId,
          tips: msg =>
            `您若保存项目问卷信息，BI中${msg}数据将会被清空，是否继续保存？`,
          callback: async isConfirm => {
            if (!isConfirm) {
              //问卷重复弹窗点击取消
              this.submiting = false;
              return;
            }
            // 校验问卷内容是否重合度过高
            this.$checkQuestionnaireIsAlike({
              projectId: this.projectId,
              projectType: this.projectType,
              webStr: this.$dealQuestionnaire(data.questions),
              callback: async isConfirm => {
                if (!isConfirm) {
                  //问卷重复弹窗点击取消
                  this.submiting = false;
                  return;
                }
                try {
                  await addUpdateQuestionnaire(data);
                  //Origin源数据用于保存时对比是否编辑
                  //保存时将源对比数组更新
                  this.questionListOrigin = this.questionList;
                  this.commonOrigin = this.common;
                  this.$sentry.captureMessage(
                    `问卷手动保存-${this.projectId}`,
                    {
                      level: 'info',
                      contexts: {
                        data: {
                          json: JSON.stringify(data)
                        }
                      }
                    }
                  );
                  this.$router.push({
                    name: 'edit',
                    query: {
                      id: this.projectId
                    }
                  });
                } catch (error) {
                  console.log(error);
                } finally {
                  this.submiting = false;
                }
              }
            });
          }
        });
      }
    },

    /////////////////////////////////////////////////拖拽/////////////////////////////////////////////////////////
    // 开始拖拽目标
    handleDragStart(e, item) {
      let { className } = e.target;
      if (className.includes('move-img')) {
        this.dragging = item;
        return false;
      }
      this.dragging = null;
    },
    // 放置目标
    handleDragEnd() {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      if (!this.dragging) {
        return false;
      }
      e.dataTransfer.dropEffect = 'move'; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    // 此处直接使用drop 未使用 dragenter
    handleDrop(e, item) {
      if (!this.dragging) {
        return false;
      }
      e.dataTransfer.effectAllowed = 'move'; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      const right = this.questionList.indexOf(this.dragging);
      const left = this.questionList.indexOf(item);
      this.questionList.splice(left, 0, ...this.questionList.splice(right, 1));
    },

    /////////////////////////////////////////////iframe/////////////////////////////////////////////////////////////////////
    iframeLoad() {
      this.$nextTick(() => {
        let data = {
          tSaasQuestionnaire: this.common,
          questionnaireTopicList: []
        };
        this.questionList.forEach((item, index) => {
          let { list, id, ...option } = item;
          data.questionnaireTopicList[index] = item;
          // 新建时没有ID，使用时间戳的不提交ID字段
          if (data.questionnaireTopicList[index].id < 10000000) {
            data.questionnaireTopicList[index].id = id;
          }
          if (option.type == 5) {
            data.questionnaireTopicList[index].manyTitleJson = list;
          } else {
            data.questionnaireTopicList[index].optionJson = list;
          }
        });
        let ifrDom = document.getElementById('iframe');
        ifrDom.contentWindow.emitPreview(data);
        setTimeout(() => {
          this.ifrHeight =
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        }, 500);
      });
    },
    // 点击预览 ， 向iframe 传入数据
    preveiw() {
      this.dialogVisible = true;
    },
    importTemplateSuccess(list) {
      this.dealOptions(list, 'questionList');
    },
    dealOptions(list, dealListName) {
      /*
        dealListName:需要经过处理的数组之前是写死的this.questionList
        因为需要对比所以需要传数字名
      */
      this[dealListName] = list
        .map((item, index) => {
          let { optionJson, manyTitleJson, ...options } = item;
          let questionItem = options;
          let childList = optionJson || manyTitleJson || ['选项1'];
          questionItem.list = childList;
          questionItem.fileListLength = questionItem.fileListLength || 1;
          this.fileTypeList.includes(item.type)
            ? optionJson.length === 0
              ? (questionItem.fileListLength = 1)
              : (questionItem.fileListLength = optionJson)
            : '';
          questionItem.type = parseInt(questionItem.type);
          questionItem.weight = parseInt(questionItem.weight || index + 1);
          questionItem.isMustFill = parseInt(questionItem.isMustFill);
          return questionItem;
        })
        .sort((a, b) => a.weight - b.weight);
    },
    scrollFn(e) {
      const { scrollTop } = e.target;
      if (scrollTop > this.scrollTop) {
        this.scrollTop = scrollTop;
        this.scrollIndex += 5;
      }
    },
    //可配置/调研场景-场景 20 5 隐藏姓名题
    showUserName(projectType) {
      if ([20, 5].includes(Number(projectType))) {
        this.typeList[3].list = this.typeList[3].list.filter(item => {
          return item['title'] !== '姓名';
        });
      }
    },
    toQuestion() {
      this.$router.push({
        name: 'edit',
        query: {
          id: this.$route.query.id,
          projectType: this.$route.query.projectType
        }
      });
    },
    /**
     * @param objValue 比对的数据1
     * @param otherObjValue 比对的数据2
     * @return true数据一样 false数据不一样
     */
    deepEqual(objValue, otherObjValue) {
      // 基本类型比较
      if (objValue === otherObjValue) {
        return true;
      }
      // 类型不同或者一个是null一个是undefined
      if (
        typeof objValue !== typeof otherObjValue ||
        objValue === null ||
        otherObjValue === null
      ) {
        return false;
      }
      // 数组或者对象的比较
      if (Array.isArray(objValue) && Array.isArray(otherObjValue)) {
        if (objValue.length !== otherObjValue.length) {
          return false;
        }
        for (let i = 0; i < objValue.length; i++) {
          if (!this.deepEqual(objValue[i], otherObjValue[i])) {
            return false;
          }
        }
        return true;
      } else if (
        typeof objValue === 'object' &&
        typeof otherObjValue === 'object'
      ) {
        const obj1Keys = Object.keys(objValue);
        const obj2Keys = Object.keys(otherObjValue);

        if (obj1Keys.length !== obj2Keys.length) {
          return false;
        }
        for (const key of obj1Keys) {
          if (
            !Object.prototype.hasOwnProperty.call(otherObjValue, key) ||
            !this.deepEqual(objValue[key], otherObjValue[key])
          ) {
            return false;
          }
        }
        return true;
      }
      // 其他类型不相等
      return false;
    }
  },
  watch: {
    changeItemFlag(v) {
      this.draggable = !v;
    },
    changeTitleFlagIndex(v) {
      this.draggable = v == -1 ? true : false;
    }
  },
  async created() {
    this.showUserName(this.projectType);
    this.projectId || this.checkProjectId();
    let { questionnaireId } = this.$route.query;
    if (questionnaireId) {
      let {
        data: {
          data: { tSaasQuestionnaire, questionnaireTopicList }
        }
      } = await questionnaireData({
        projectId: this.projectId,
        projectType: this.projectType
      });
      this.common = tSaasQuestionnaire;
      //已编辑的调查问卷项目
      questionnaireTopicList.forEach(item => {
        if (item.type === 19) {
          if (!item.rule) {
            item.rule = {
              minNum: '',
              maxNum: '',
              numberType: 0 // 1显示小数 0不显示
            };
          } else {
            try {
              item.rule = JSON.parse(item.rule);
            } catch (e) {
              console.error(e);
            }
          }
        }
      });
      //Origin源数据用于保存时对比是否编辑
      this.commonOrigin = JSON.parse(JSON.stringify(this.common));
      this.dealOptions(questionnaireTopicList, 'questionList');
      this.dealOptions(questionnaireTopicList, 'questionListOrigin');
      //储存初始化数据
      this.oldQuestionList = {
        common: JSON.parse(JSON.stringify(this.common)),
        questionList: JSON.parse(JSON.stringify(this.questionList))
      };
    }

    // 自动保存60s
    this.timer = setInterval(() => {
      this.save(true);
    }, 60 * 1000);
    try {
      document
        .querySelector('.app-content')
        .addEventListener('scroll', this.scrollFn);
    } catch (error) {
      this.scrollIndex = 500;
    }
  },
  beforeRouteLeave(to, from, next) {
    //离开路由时对比是否编辑
    //编辑过后弹窗提示保存
    const questionListEqual =
      JSON.stringify(this.questionListOrigin) ==
      JSON.stringify(this.questionList);
    const commonEqual =
      JSON.stringify(this.common) == JSON.stringify(this.commonOrigin);
    if (questionListEqual && commonEqual) {
      next();
    } else {
      // 浏览器前进后退
      if (this.$route.fullPath !== window.location.href.split('/#')[1]) {
        window.confirm('当前页面未保存是否继续跳转?')
          ? next()
          : window.history.forward();
        return;
      }
      this.$confirm('当前页面未保存是否继续跳转', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        next();
      });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (document.querySelector('.app-content')) {
      document
        .querySelector('.app-content')
        .removeEventListener('scroll', this.scrollFn);
    }
  }
};
</script>
<style lang="scss">
.el-textarea.is-disabled,
.is-disabled,
.el-textarea__inner {
  cursor: default !important;
}
.question {
  .el-rate__icon {
    font-size: 30px;
  }
  .question-edit-sort-input {
    .el-input__inner {
      padding: 0 8px;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
$--left-width: 26%;
$--right-width: 65.3%;

.question-right-c {
  ::v-deep {
    textarea[disabled] {
      pointer-events: none;
    }
  }
}
.remark-input:hover,
.textarea-title:hover {
  border: 1px dashed #dddddd;
  cursor: default;
}
.remark-input {
  border: 1px dashed rgba(0, 0, 0, 0);
}
.textarea-title {
  padding: 10px;
  border: 1px dashed rgba(0, 0, 0, 0);
  cursor: default;
}
.ghost {
  // width: 100px;
  height: 20px;
  border: 2px dashed #1890ff !important;
  // background-color: red !important;
}
.chosen {
  border: solid 2px #3089dc;
}
.draggingStyle {
  height: unset !important;
  transform: translateY(-80%) scale(0.8);
  z-index: 1000000;
  // background-color: red !important;
}
.preview {
  width: 375px;
  height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
}
.question {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 33px 6.6%;
  height: auto;
  // 左侧
  &-left {
    width: $--left-width;
    min-width: 250px;
    height: auto;
    .block-title {
      text-align: center;
      font-weight: bold;
      font-size: 18px;
    }
    .template {
      padding: 20px;
      background: #f7fbff;
      border: 1px solid #dddddd;
      .template-group {
        margin-top: 15px;
        display: flex;
        align-items: center;
      }
      p {
        margin-top: 15px;
        font-size: 12px;
        color: #999999;
      }
    }
    .question-type {
      padding: 20px;
      background: #f7fbff;
      border: 1px solid #dddddd;
      margin-top: 20px;
    }
    // 标题
    &-title {
      margin-bottom: 15px;
    }
    // 内容
    &-item2 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 38%;
        min-width: 100px;
        min-height: 44px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        align-items: center;

        font-size: 14px;
        color: #999999;
        margin-bottom: 21px;
        padding: 0 12px;
        img {
          width: 18px;
          height: 18px;
          margin-right: 14px;
        }
      }
    }
  }
  // 右侧
  &-right {
    width: $--right-width;
    min-width: 500px;
    background: rgba(255, 255, 255, 1);
    // 按钮
    &-bts {
      display: flex;
      justify-content: center;
      margin-top: 26px;
      .el-button {
        width: 120px;
      }
    }
    &-top {
      &-upload {
        width: 33.9vw;
        height: 22.4vw;
        background: rgba(245, 245, 245, 1);
        margin: auto;
        margin-bottom: 50px;
        text-align: center;
        display: block;
        position: relative;
        .logo-icon {
          width: 20.92%;
          height: auto;
          margin-top: 15%;
          margin-bottom: 6%;
        }
        .upload-icon {
          width: 18px;
          height: 18px;
          position: absolute;
          right: 22px;
          top: 22px;
        }
        p {
          font-size: 14px;
          color: #333;
        }
      }
    }
    // 内容
    &-c {
      width: 100%;
      border: 1px solid rgba(221, 221, 221, 1);
      padding: 30px 7.42%;
      display: flex;
      flex-direction: column;
    }
    // 元素
    .item {
      transition: all linear 0.3s;
      margin-bottom: 30px;
      &-title {
        // display: flex;
        // justify-content: space-between;
        // margin-bottom: 8px;
      }
      &-mr {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      &-title__p {
        display: flex;
        align-items: flex-start;
        margin: 15px 0;
        font-size: 16px;
        textarea {
          padding: 2px 0;
          width: 100%;
        }
      }
      &-content {
        padding-left: 50px;
        margin-top: 10px;
        // padding: 0 30px;
        // 子元素 输入框
        .item2-input {
          width: 80%;
        }
        .item2-input:disabled {
          background: #fff;
        }
        // 子元素 文本框
        .item2-text {
          height: 38px;
          padding: 0 7px;
          border: 1px solid rgba(221, 221, 221, 1);
        }
        // 子元素 更多文本
        &-textmore {
          .item2-text {
            margin-top: 10px;
          }
        }
        // 选择项
        &-inputs {
          &-ul {
            li:hover {
              border-color: #dddddd;
            }
            li {
              padding: 10px;
              border: 1px dashed transparent;
              position: relative;
              .item2-remove {
                width: 21px;
                height: 18px;
                position: absolute;
                top: 50%;
                right: 30px;
                transform: translateY(-50%);
              }
            }
          }
          // 子添加
          &-add {
            margin-top: 13px;
            font-size: 12px;
            color: #1989fa;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              margin-right: 12px;
            }
          }
        }
        &-19 {
          div {
            display: flex;
            align-items: center;
            margin: 15px;
            .el-input {
              width: 120px;
            }
          }
        }
      }
    }
  }
}
@mixin d {
  position: absolute;
  content: '';
  border-radius: 3px;
  background: #ccc;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.enclosure {
  ul {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 99px;
      height: 99px;
      border-radius: 8px;
      background: #f1f1f1;
      position: relative;
      margin-bottom: 5px;
      background-image: url('http://cdn.yxvzb.com/WEB/SaaS/images/file2.png');
      background-size: 50% 50%;
      background-repeat: no-repeat;
      background-position: center;
      // &::before {
      //   width: 48px;
      //   height: 5px;
      //   @include d;
      // }
      // &::after {
      //   width: 5px;
      //   height: 48px;
      //   @include d;
      // }
    }
  }
  p {
    color: #cccccc;
    margin-top: 10px;
  }
  .box {
    width: 250px;
    height: 150px;
    display: flex;
    line-height: 200px;
    align-items: center;
    justify-content: center;
    background: #efefef;
    border-radius: 2px;
    margin-top: 20px;
    img {
      width: 20px;
      height: 23px;
      vertical-align: center;
      margin-right: 10px;
    }
    span {
      color: #1890ff;
    }
  }
}
</style>
